import React, { FC, Fragment, useContext } from 'react';
import LoadingPage from '../common/LoadingPage';
import { DataContext } from '../context/dataLoader/DataLoader';

import './BookViewer.scss';
import RedactedWord from './RedactedWord';

const BookViewer: FC = () => {

    const { book } = useContext(DataContext)


    if (!book) {
        return <LoadingPage />
    }

    if (book.collection.length !== 1) {
        return <LoadingPage>Book data is invalid.</LoadingPage>
    }

    const collection = book.collection[0];


    return <div className='Page BookViewer serif'>
        <h2>The Book of Blaseball</h2>
        <div className='subheader'>
            <Redacted bigWords line="The game of |||||||||||||||||| and |||||||||||||" />
        </div>
        <h3>{collection.header.title}</h3>


        {
            collection.sections.map((section, idx) => (
                <ol key={idx}>
                    <h4>{idx + 1}. <Redacted line={section.bullet} /></h4>
                    {
                        section.subbullets.map(((subbullet, idx) => (
                            <li key={idx}>
                                {String.fromCharCode('a'.charCodeAt(0) + idx)}. <Redacted line={subbullet} />
                            </li>
                        )))
                    }
                </ol>
            ))
        }


        <div className='footer'>
            <div className='bullet'>{collection.footer.header}</div>
            {
                collection.footer.text.map((text, idx) => (
                    <div className='subbullet' key={idx}>(TODO show signatures right)</div>
                ))
            }
        </div>
    </div>
}

export default BookViewer;

interface props {
    line: string,
    bigWords?: boolean
}

type element = {
    _type: "text" | "redacted",
    body: string
}

const Redacted: FC<props> = (props) => {
    const { line, bigWords } = props;

    const words = line.split(" ")

    const elements: element[] = [];

    function isRedacted(word: string): boolean {
        return word.charAt(0) === "|"
    }
    function makeEl(word: string): element {
        return {
            _type: (isRedacted(word) ? "redacted" : "text"),
            body: word
        }
    }

    let currentEle = makeEl(words[0]);
    for (var i = 1; i < words.length; i++) {
        const nextWord = words[i];
        if (!isRedacted(nextWord) && currentEle._type === "text") {
            currentEle.body += " " + nextWord;
        } else {
            elements.push(currentEle)
            currentEle = makeEl(nextWord)
        }
    }
    elements.push(currentEle)


    return <span>
        {
            elements.map((element, idx) => {
                if (element._type === "text") {
                    return <Fragment key={idx}>
                        {element.body}
                    </Fragment>
                } else {
                    return <RedactedWord key={idx} length={element.body.length} bigWords={bigWords} />
                }
            })
        }
    </span>
}
